import { locationRoute, menuRoute } from "@/App";
import { useSuspenseQuery } from "@tanstack/react-query";
import { allMenusQueryOptions } from "./useMenu";
import { useLocation } from "@/providers/LocationContextProvider";
import { useNavigate } from "@tanstack/react-router";
import { useMemo } from "react";

export const useLocationMenus = () => {
  const { locationId } = locationRoute.useParams();
  const search = locationRoute.useSearch();
  const { table } = search as { table?: string };
  const navigate = useNavigate();

  if (!locationId) {
    throw new Error("Location ID is not defined");
  }
  const { orderType, setOrderType } = useLocation();
  const allMenus = useSuspenseQuery(allMenusQueryOptions(locationId));

  if (!allMenus.data) {
    throw new Error("No menus found");
  }
  if (allMenus.isError) {
    throw new Error("Error fetching menus");
  }

  const hasTakeAwayMenu = allMenus.data.some(
    (menu) => menu.type === "TAKE_AWAY"
  );
  //const hasDeliveryMenu = allMenus.data.some((menu) => menu.type === 'DELIVERY');
  const hasDineInMenu = allMenus.data.some((menu) => menu.type === "DINE_IN");

  if (orderType === "TAKE_AWAY" && !hasTakeAwayMenu) {
    console.log(
      "Attempted to access take away, but no take away menu available"
    );
    setOrderType(null);
    navigate({
      to: locationRoute.to,
    });
  }

  if (orderType === "DINE_IN" && !hasDineInMenu) {
    console.log("Attempted to access dine in, but no dine in menu available");
    setOrderType(null);
    navigate({
      to: locationRoute.to,
    });
  }

  const availableMenus = useMemo(() => {
    return allMenus.data.filter((menu) => {
      if (!orderType) return true;
      return menu.type === orderType;
    });
  }, [allMenus.data, orderType]);

  const hasMultipleMenus = useMemo(() => {
    return availableMenus.length > 1;
  }, [availableMenus]);

  function changeMenu(menuId: string) {
    navigate({
      to: menuRoute.to,
      params: { locationId, menuId },
      search: { table },
      viewTransition: true,
    });
  }

  return {
    allMenus: allMenus.data,
    availableMenus,
    hasMultipleMenus,
    hasTakeAwayMenu,
    //hasDeliveryMenu,
    hasDineInMenu,
    changeMenu,
  };
};
